import React from 'react';

import SeedlingSvg from '../resources/icons/seedling.svg';
import PaperPlaneSvg from '../resources/icons/paper-plane.svg';
import CubeSvg from '../resources/icons/cube.svg';  
import CubesSvg from '../resources/icons/cubes.svg';  
import FireFameIconSvg from '../resources/icons/fire-flame-curved.svg';
import WalletFireSvg from '../resources/icons/blanket-fire.svg';
import ShieldSvg from '../resources/icons/shield-halved.svg';

import Icon from '@ant-design/icons';

const CubeIcon = (props) => <Icon component={CubeSvg} />;
const CubesIcon = (props) => <Icon component={CubesSvg} />;
const SeedlingIcon = (props) => <Icon component={SeedlingSvg} />;
const PaperPlaneIcon = (props) => <Icon component={PaperPlaneSvg} />;
const FireFlameIcon = (props) => <Icon component={FireFameIconSvg} />;
const WalletFireIcon = (props) => <Icon component={WalletFireSvg} />;
const ShieldIcon = (props) => <Icon component={ShieldSvg} />;

export { CubeIcon, CubesIcon, SeedlingIcon, PaperPlaneIcon, FireFlameIcon, WalletFireIcon, ShieldIcon };